import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
export function getContentStyle(alignContent, verticalAlign) {
  var style = {
    display: 'flex'
  };
  var alignContentStyle = {
    center: {
      textAlign: 'center',
      justifyContent: 'center'
    },
    left: {
      textAlign: 'left',
      justifyContent: 'left'
    },
    right: {
      textAlign: 'right',
      justifyContent: 'right'
    }
  };
  var verticalAlignStyle = {
    top: {
      alignItems: 'flex-start'
    },
    middle: {
      alignItems: 'center'
    },
    bottom: {
      alignItems: 'flex-end'
    }
  };
  style = _objectSpread(_objectSpread({}, style), alignContentStyle[alignContent]);
  style = _objectSpread(_objectSpread({}, style), verticalAlignStyle[verticalAlign]);
  return style;
}